import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18548 Отключение промо редактора документов
 */
export const VIEWER_DOC_DISABLE_PROMO_SNACKBAR = getFeature('viewer-doc-disable-promo-snackbar') || false;
